import { cloneDeep, isEmpty, omitBy, isFunction, set } from "lodash-es"
import React, { useEffect, useState } from "react"
import CustomButton from "../Atoms/CustomButton"
import CustomDrawer from "../Atoms/CustomDrawer"
import FormController from "../Molecules/FormController"
import IconBadge from "../Molecules/IconBadge"
import { Callout } from "@blueprintjs/core"
import classNames from "utils/classNames"

type SearchFilterCalloutProps = {
  children?: React.ReactNode
  className?: string
  title?: string
  fill?: boolean
}
export const SearchFilterCallout = ({
  className,
  title,
  fill = null,
  children,
}: SearchFilterCalloutProps) => {
  return (
    <Callout
      className={classNames(
        "mb-3",
        {
          "vt-searchfilter-callout-fill": fill,
        },
        className
      )}
      title={title}
    >
      {children}
    </Callout>
  )
}

type SearchFilterProps = {
  [key: string]: any
}
const SearchFilter = ({
  onOpen,
  isOpen: isOpenProps,
  onClose: onCloseProps,
  btnProps,
  children,
  getValues,
  onClear,
  className,
  icon,
  style,
  drawerClassName,
  title,
  size,
  value,
  isCloseButtonShown,
  drawerOverlayClassName,
  badgeClassName,
  ...drawerProps
}: SearchFilterProps) => {
  const [isOpen, toggleOpen] = useState(false)
  const [filter, setFilter] = useState({})
  useEffect(() => {
    setFilter(value)
  }, [value])

  useEffect(() => {
    if (isOpenProps !== undefined) {
      if (isOpenProps === false || isOpenProps === true) {
        toggleOpen(isOpenProps)
      }
    }
  }, [isOpenProps, toggleOpen])
  const handleClose = () => {
    isOpenProps !== undefined ? onCloseProps() : toggleOpen(false)
    getValues && getValues(filter)
  }

  const handleChange = (path, value) => {
    const filterCopy = cloneDeep(filter)
    set(filterCopy, path, value)
    setFilter(filterCopy)
  }

  return (
    <>
      <IconBadge
        className={badgeClassName}
        intent="danger"
        show={!isEmpty(omitBy(value, isEmpty))}
      >
        <CustomButton
          icon={icon}
          {...btnProps}
          className={className}
          style={style}
          onClick={e => {
            onOpen ? onOpen() : toggleOpen(isOpen => !isOpen)
          }}
        />
      </IconBadge>
      <CustomDrawer
        drawerClassName={drawerOverlayClassName}
        className={classNames("vt-search-filter-drawer", drawerClassName)}
        isOpen={isOpen}
        onClose={handleClose}
        icon={icon}
        title={title}
        size={size}
        isCloseButtonShown={isCloseButtonShown}
        footer={
          <>
            <CustomButton
              text="Filter"
              className="mr-2"
              icon="filter"
              intent="primary"
              onClick={handleClose}
            />
            <CustomButton
              icon="refresh"
              minimal={true}
              text="Clear"
              onClick={e => {
                setFilter({})
                onClear()
              }}
            />
          </>
        }
        {...drawerProps}
      >
        <div className="p-3">
          <FormController source={filter} onChange={handleChange}>
            {isFunction(children) ? children(filter) : children}
          </FormController>
        </div>
      </CustomDrawer>
    </>
  )
}

SearchFilter.defaultProps = {
  title: "Filter Items",
  icon: "filter",
  size: "410px",
  isCloseButtonShown: true,
}
export default SearchFilter
